/* istanbul ignore file */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
import type { ChargeCategory } from '../models/ChargeCategory';

export class ChargeCategoriesService {
  public static chargeCategoriesControllerFindAllActive(): CancelablePromise<ChargeCategory[]> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/charge-categories',
    });
  }
}
